module.exports = __webpack_public_path__ + "img/ioutlet_logo.f3d8ce34.png";